import type { StatisticHeadCell } from "@interfaces/table";

export const statisticCells: StatisticHeadCell[] = [
  {
    id: "statusName",
    numeric: true,
    disablePadding: false,
    label: "Status",
    width: 130,
    sort: true,
  },
  {
    id: "orderNumber",
    numeric: true,
    disablePadding: false,
    label: "Order #",
    width: 50,
    sort: true,
  },
  {
    id: "proNumber",
    numeric: true,
    disablePadding: false,
    label: "PRO #",
    width: 50,
    sort: true,
  },
  {
    id: "puDate",
    numeric: true,
    disablePadding: false,
    label: "PU Date",
    width: 100,
    sort: true,
  },
  {
    id: "puCityName",
    numeric: true,
    disablePadding: false,
    label: "PU City",
    width: 150,
    sort: true,
  },
  {
    id: "delCityName",
    numeric: true,
    disablePadding: false,
    label: "DEL City",
    width: 150,
    sort: true,
  },
  {
    id: "delDate",
    numeric: true,
    disablePadding: false,
    label: "DEL Date",
    width: 100,
    sort: true,
  },
  {
    id: "podDate",
    numeric: true,
    disablePadding: false,
    label: "POD Date",
    width: 100,
    sort: true,
  },
  {
    id: "commodityName",
    numeric: true,
    disablePadding: false,
    label: "Commodity",
    width: 100,
    sort: true,
  },
  {
    id: "weight",
    numeric: true,
    disablePadding: false,
    label: "Weight",
    width: 50,
    sort: true,
  },
  {
    id: "pallets",
    numeric: true,
    disablePadding: false,
    label: "Pallets",
    width: 50,
    sort: true,
  },
  {
    id: "onTime",
    numeric: true,
    disablePadding: false,
    label: "On time",
    width: 100,
    sort: true,
  },
];
